import React from 'react';
import styled from 'styled-components';
import { padding } from 'polished';
import { ClipLoader } from 'react-spinners';
import { formatPrice } from 'utils/price';
import dayjs from 'dayjs';
import { colors } from 'styles/theme';
import { ProgressBar } from 'components/ProgressBar';
import { BudgetCardProps } from 'pages/Totem/TotemDashboard/TotemDashboard.types';
import { useGetMonthlyUsedBudgetFromDateQuery } from 'data/__generated__';

export interface BudgetDetailInfoProps extends Pick<BudgetCardProps, 'totemId'> {
    totemMonthlyBudget: number;
    date: number;
}

export const BudgetDetailInfo: React.FC<BudgetDetailInfoProps> = ({ date, totemId, totemMonthlyBudget }) => {
    const currentMonth = dayjs(date).locale('fr').format('MMMM');

    const { loading, data } = useGetMonthlyUsedBudgetFromDateQuery({
        variables: { totemId, date },
    });

    return (
        <Container>
            <BudgetInfoText>
                Total dépensé sur le mois de {currentMonth} :{' '}
                {loading ? (
                    <ClipLoader size="12px" color={colors.pantinGrey} />
                ) : (
                    formatPrice(data?.getMonthlyUsedBudgetFromDateQuery ?? 0)
                )}
            </BudgetInfoText>
            <BudgetChart>
                <BudgetData>
                    <BudgetSpent>
                        {loading ? (
                            <ClipLoader size="18px" />
                        ) : (
                            formatPrice(data?.getMonthlyUsedBudgetFromDateQuery ?? 0)
                        )}
                        /
                    </BudgetSpent>
                    <BudgetAvailable>{formatPrice(totemMonthlyBudget)}</BudgetAvailable>
                </BudgetData>
                <ProgressBar
                    max={totemMonthlyBudget}
                    value={loading ? 0 : (data?.getMonthlyUsedBudgetFromDateQuery ?? 0)}
                />
            </BudgetChart>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    width: 100%;
    ${(props) => padding(props.theme.variables.padding, 0)};
    justify-content: flex-end;
`;

const BudgetSpent = styled.div`
    font-size: 20px;
`;

const BudgetAvailable = styled.div`
    font-size: 14px;
`;

const BudgetData = styled.div`
    display: flex;
    font-weight: 800;
    align-items: baseline;
    font-family: Sharp Grotesk;
`;

const BudgetChart = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    align-items: flex-end;
`;

const BudgetInfoText = styled.div`
    color: ${(props) => props.theme.colors.pantinGrey};
    font-weight: 500;
    font-size: 16px;
    align-self: flex-end;
    margin-right: 20px;
`;
